import { Buffer } from 'buffer'
import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import { createI18n } from 'vue-i18n'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import './index.css'

import App from './App.vue'
import LandingPage from './views/LandingPage.vue'
import GiftBoxApp from './components/GiftBoxApp.vue'
import ClaimView from './views/ClaimView.vue'
import en from './locales/en.json'

// Polyfills for ethers.js
if (!globalThis.Buffer) {
  globalThis.Buffer = Buffer
}
if (!globalThis.global) {
  globalThis.global = globalThis
}
if (!globalThis.process) {
  globalThis.process = {
    browser: true,
    env: { NODE_ENV: import.meta.env.MODE },
    version: '',
    release: {},
    platform: 'browser',
    cwd: () => '/',
    nextTick: (cb: any) => Promise.resolve().then(cb),
    hrtime: () => [0, 0],
    versions: {},
    on: () => undefined,
    off: () => undefined,
    emit: () => false,
    listeners: () => []
  } as any
}

// Router configuration
const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Landing',
      component: LandingPage
    },
    {
      path: '/create',
      name: 'Create',
      component: GiftBoxApp
    },
    {
      path: '/claim/:currency?',
      name: 'Claim',
      component: ClaimView
    }
  ]
})

// i18n configuration
const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en
  }
})

// Create and mount app
const app = createApp(App)

app.use(router)
app.use(i18n)
app.use(Toast, {
  position: 'top-right',
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false
})

app.mount('#app')
